import React, { Component } from 'react';
import FbrService from '../service/FbrService';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dropdown } from 'primereact/dropdown';
import { SplitButton } from 'primereact/splitbutton';
import { ProgressSpinner } from 'primereact/progressspinner';
import 'moment/locale/fr';
import moment from 'moment';
import { ColumnGroup } from 'primereact/columngroup';
import { Row } from 'primereact/row';

export class FormStatFactureTrim extends Component {
    constructor() {
        super();
        this.state = {
            liste_annee: [{ label: parseInt(moment(new Date()).format('YYYY')), value: parseInt(moment(new Date()).format('YYYY')) }],
            rannee: parseInt(moment(new Date()).format('YYYY')),
            rtrim: '1',
            rRegion: null,
            rPref: null,
            rCrd: null,
            rtypePrest: null,
            liste_bailleur: [],
            ridBailleur: null,
            liste_data: [],
            liste_type_prest: [],
            liste_region: [],
            liste_all_pref: [],
            liste_pref: [],
            liste_all_crd: [],
            liste_crd: [],
            libM1: 'Jan',
            libM2: 'Fev',
            libM3: 'Mars',
            items: [
                {
                    label: 'Format CSV',
                    icon: 'pi pi-print',
                    command: (e) => {
                        this.dt.exportCSV();
                    }
                }
            ],
            showindicator: false,
            userconnected: JSON.parse(localStorage.getItem('userconnected')),
        };
        this.FbrService = new FbrService();
    }


    componentDidMount() {
        let an = 2021;
        let liste_annee = [];
        while (an <= parseInt(moment(new Date()).format('YYYY'))) {
            liste_annee.push({ label: an, value: an });
            an++;
        }
        this.FbrService.get_liste_prefecture().then(data => {
            if (data != null && data != undefined) {
                this.setState({ liste_all_pref: data });
            }
        });
        this.FbrService.get_liste_crd().then(data => {
            if (data != null && data != undefined) {
                this.setState({ liste_all_crd: data });
            }
        });
        this.get_liste_codif();
        this.setState({ liste_region: this.FbrService.get_liste_regions(), liste_annee: liste_annee }, () => {
            this.get_liste_data();
        });
    }

 
    get_liste_codif() {
        this.setState({ showindicator: true });
        this.FbrService.get_liste_prestataire_eval().then(data => {
            this.setState({ showindicator: false });
            if (data !== null && data !== undefined && data !== '') {
                if (data.length > 0) {
                    let liste = data.map(x => {
                        return { value: x.idPrest, label: x.nomPrest, typePrest: x.typePrest.libCodif, idTypePrest: x.typePrest.idCodif, regionSite: x.idSite.regionSite, prefectureSite: x.idSite.prefectureSite, crdSite: x.idSite.crdSite }
                    }).filter(function (el) {
                        return (el.typePrest == 'RECO-ASC' || el.typePrest == 'PS' || el.typePrest == 'Hopital' || el.typePrest == 'CS' || el.typePrest == 'DPS' || el.typePrest == 'DRS');
                    });
                    this.setState({ listeprest: liste, listeprest_all: liste });
                }
            }
        });
        this.FbrService.get_liste_codif('TYPE_PRESTATAIRE').then(data => {
            this.setState({ showindicator: false });
            if (data.length > 0) {
                let liste = data.map(x => {
                    return { value: x.idCodif, label: x.libCodif }
                }).filter(function (el) {
                    return (el.label == 'RECO-ASC' || el.label == 'PS' || el.label == 'Hopital' || el.label == 'CS' || el.label == 'DPS' || el.label == 'DRS');
                });
                this.setState({ liste_type_prest: liste });
            }
        });
        this.setState({ showindicator: true });
        this.FbrService.get_liste_codif('BAILLEUR').then(data => {
            this.setState({ showindicator: false });
            if (data.length > 0) {
                let liste = data.map(x => {
                    return { value: x.idCodif, label: x.libCodif }
                });
                this.setState({ liste_bailleur: liste });
            }
        });
    }



    get_liste_data() {
        let region = 'Tous';
        let pref = 'Tous';
        let crd = 'Tous';
        let rtype = 'Tous';
        let ridBailleur = 'Tous';
        if (this.state.rCrd !== 'Tous' && this.state.rCrd !== undefined && this.state.rCrd !== null) {
            crd = this.state.rCrd;
        }
        if (this.state.rRegion !== 'Tous' && this.state.rRegion !== undefined && this.state.rRegion !== null) {
            region = this.state.rRegion;
        }
        if (this.state.rPref !== 'Tous' && this.state.rPref !== undefined && this.state.rPref !== null) {
            pref = this.state.rPref;
        }
        if (this.state.rtypePrest !== 'Tous' && this.state.rtypePrest !== undefined && this.state.rtypePrest !== null) {
            rtype = this.state.rtypePrest;
        }
        if (this.state.ridBailleur !== 'Tous' && this.state.ridBailleur !== undefined && this.state.ridBailleur !== null) {
            ridBailleur = this.state.ridBailleur;
        }
        this.setState({ showindicator: true });
        this.FbrService.get_tt_facture_trim(this.state.rannee, this.state.rtrim, region, pref, crd, rtype,ridBailleur).then(data => this.setState({ liste_data: data, showindicator: false }));
    }



    select_pref(region) {
        let liste = [];
        if (this.state.liste_all_pref != null && this.state.liste_all_pref != undefined) {
            if (this.state.liste_all_pref.length > 0) {
                let liste_filtre = this.state.liste_all_pref.filter(function (el) {
                    return el.region == region;
                });
                if (liste_filtre != null && liste_filtre != undefined) {
                    if (liste_filtre.length > 0) {
                        liste = liste_filtre.map(x => {
                            return { value: x.nom_pref, label: x.nom_pref }
                        });
                    }
                }
            }
        }
        this.setState({ liste_pref: liste });
    }

    select_crd(pref) {
        let liste = [];
        if (this.state.liste_all_crd != null && this.state.liste_all_crd != undefined) {
            if (this.state.liste_all_crd.length > 0) {
                let liste_filtre = this.state.liste_all_crd.filter(function (el) {
                    return el.nom_pref == pref;
                });
                if (liste_filtre != null && liste_filtre != undefined) {
                    if (liste_filtre.length > 0) {
                        liste = liste_filtre.map(x => {
                            return { value: x.nom_crd, label: x.nom_crd }
                        });
                    }
                }
            }
        }
        this.setState({ liste_crd: liste });
    }

    render() {
       

        return (
            <div className="card p-fluid">
                <div className="grid">
                    <div className="col-12">
                        <div className="card-w-title">
                            <i className="pi pi-search"></i> Option de recherche
                            <hr />
                            <div className="grid">
                                <div className="col-12 md:col-3">
                                    <Dropdown autoWidth={false} options={this.state.liste_annee} optionLabel='label' placeholder='Année' filter={true} filterBy='label' filterMatchMode='contains' value={this.state.rannee} onChange={e => this.setState({ rannee: e.value }, () => {
                                        //this.get_liste_data();
                                    })} />
                                </div>

                                <div className="col-12 md:col-3">
                                    <Dropdown id="idPrest" value={this.state.rtrim} options={[{ value: '1', label: 'T1' }, { value: '2', label: 'T2' }, { value: '3', label: 'T3' }, { value: '4', label: 'T4' }]} optionLabel='label' onChange={(e) => this.setState({ rtrim: e.target.value }, () => {
                                        let lm1 = '';
                                        let lm2 = '';
                                        let lm3 = '';

                                        if (this.state.rtrim == '1') {
                                            lm1 = 'Jan';
                                            lm2 = 'Fev';
                                            lm3 = 'Mars';
                                        } else if (this.state.rtrim == '2') {
                                            lm1 = 'Avr';
                                            lm2 = 'Mai';
                                            lm3 = 'Jun';
                                        } else if (this.state.rtrim == '3') {
                                            lm1 = 'Jul';
                                            lm2 = 'Aou';
                                            lm3 = 'Sep';
                                        } else {
                                            lm1 = 'Oct';
                                            lm2 = 'Nov';
                                            lm3 = 'Dec';
                                        }
                                        this.setState({
                                            libM1: lm1,
                                            libM2: lm2,
                                            libM3: lm3,
                                        }, () => {
                                           // this.get_liste_data();
                                        })
                                    })} autoWidth={false} itemTemplate={this.itemTemplate} />
                                </div>

                                <div className="col-12 md:col-3">
                                    <Dropdown autoWidth={false} options={[{ label: 'Region', value: 'Tous' }].concat(this.state.liste_region)} optionLabel='label' placeholder='Region' filter={true} filterBy='label' filterMatchMode='contains' value={this.state.rRegion} onChange={e => this.setState({ rRegion: e.value }, () => {
                                        //this.get_liste_data();
                                        this.select_pref(e.value);
                                    })} />
                                </div>

                                <div className="col-12 md:col-3">
                                    <Dropdown autoWidth={false} options={[{ label: 'Préfecture', value: 'Tous' }].concat(this.state.liste_pref)} optionLabel='label' placeholder='Préfecture' filter={true} filterBy='label' filterMatchMode='contains' value={this.state.rPref} onChange={e => this.setState({ rPref: e.value }, () => {
                                      //  this.get_liste_data();
                                        this.setState({ liste_crd: [] });
                                        this.select_crd(e.value);
                                    })} />
                                </div>

                                <div className="col-12 md:col-3">
                                    <Dropdown autoWidth={false} options={[{ label: 'CR', value: 'Tous' }].concat(this.state.liste_crd)} optionLabel='label' placeholder='CR' filter={true} filterBy='label' filterMatchMode='contains' value={this.state.rCrd} onChange={e => this.setState({ rCrd: e.value }, () => {
                                       // this.get_liste_data();
                                    })} />
                                </div>

                                <div className="col-12 md:col-3">
                                    <Dropdown autoWidth={false} options={[{ label: 'Type acteur', value: 'Tous' }].concat(this.state.liste_type_prest)} optionLabel='label' placeholder='Type acteur' filter={true} filterBy='label' filterMatchMode='contains' value={this.state.rtypePrest} onChange={e => this.setState({ rtypePrest: e.value }, () => {
                                       // this.get_liste_data();
                                    })} />
                                </div>

                                <div className="col-12 md:col-3">
                                    <Dropdown  options={[{ label: 'Bailleur', value: 'Tous' }].concat(this.state.liste_bailleur)} optionLabel='label' placeholder='Bailleur' filter={true} filterBy='label' filterMatchMode='contains' value={this.state.ridBailleur} onChange={e => this.setState({ ridBailleur: e.value }, () => {
                                       // this.get_liste_data();
                                    })} style={{width: '100%'}}/>
                                </div>

                                <div className="col-12 md:col-2">
                                    <SplitButton label="Rechercher" style={{ width: '140px', }} onClick={(e) => this.get_liste_data()} icon="pi pi-search" model={this.state.items}></SplitButton>
                                </div>

                                <div className="col-12 md:col-1">
                                    {this.state.showindicator ? <ProgressSpinner style={{ width: '30px', height: '30px' }} strokeWidth="4" fill="#EEEEEE" animationDuration=".5s" /> : null}
                                </div>
                            </div>

                          
                        </div>
                    </div>
                </div>



                <div className="grid">
                    <div className="col-12 lg-12">
                        <div className="grid">
                            <div className="col-12">
                                <DataTable value={this.state.liste_data} responsive={true} paginator={true} rows={20} paginatorPosition="top" alwaysShowPaginator={true} csvSeparator=";"
                                    ref={(el) => { this.dt = el; }} 
                                    className="p-datatable-gridlines p-datatable-striped p-datatable-md p-datatable-customers" >
                                    <Column field="ordre" header="#" style={{ width: '5%' }} />
                                    <Column field="nomPrest" header="ACTEUR" filter={true} filterMatchMode='contains' sortable/>
                                    <Column field="mtQuantM1" body={(rowData, column) => {
                                        return <div>
                                            <span>{this.FbrService.formaterValueSep(parseFloat(rowData.mtQuantM1))}</span>
                                        </div>
                                    }} header={"MT "+this.state.libM1.toUpperCase()} style={{ width: '15%' }} filter={true} filterMatchMode='contains'  sortable/>
                                    <Column field="mtQuantM2" body={(rowData, column) => {
                                        return <div>
                                            <span>{this.FbrService.formaterValueSep(parseFloat(rowData.mtQuantM2))}</span>
                                        </div>
                                    }} header={"MT "+this.state.libM2.toUpperCase()}style={{ width: '15%' }} filter={true} filterMatchMode='contains' sortable/>
                                    <Column field="mtQuantM3" body={(rowData, column) => {
                                        return <div>
                                            <span>{this.FbrService.formaterValueSep(parseFloat(rowData.mtQuantM3))}</span>
                                        </div>
                                    }} header={"MT "+this.state.libM3.toUpperCase()} style={{ width: '15%' }} filter={true} filterMatchMode='contains' sortable/>
                                   
                                    <Column field="mtQuant" body={(rowData, column) => {
                                        return <div>
                                            <span>{this.FbrService.formaterValueSep(parseFloat(rowData.mtQuant))}</span>
                                        </div>
                                    }} style={{ width: '15%' }} header="TOTAL" filter={true} filterMatchMode='contains' sortable />

                                </DataTable>
                            </div>
                        </div>
                    </div>
                </div>


            </div>
        );
    }
}